export default (props: any) => {

  return {
    company: props.company,
    userID: props.userID,
    mileage: props.mileage,
    title: props.title,
    description: props.description
  }
}